// src/components/PrivateLayout.tsx
import React, { ReactNode, useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

import NavBar from '../common/UI/Nabvar';
import SideBar from '../common/UI/SideBar';
import AppHeader from '../common/UI/Header/AppHeader';
import Footer from '../common/UI/Footer';

import { useItemsStore } from '../store/items.store';
import TokenRefreshModal from '../common/UI/TokenRefreshModal';

import style from './PrivateLayout.module.css';
import { useAuth } from '../contexts/AuthContext';

const PrivateLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [height, setHeight] = useState('calc(100vh - 105px)');
  const { refreshModal } = useAuth(); // <-- obtenemos el estado/acciones del modal

  const itemsStorage = useItemsStore(
    (state) => ({
      items: state.items,
      setItems: state.setItems,
    }),
    shallow
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 678) {
        setHeight('calc(100vh - 64px)');
      } else {
        setHeight('calc(100vh - 64px - 47px)');
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="AppLayout">
      <SideBar itemsSideBar={itemsStorage.items} />
      <section className="home-section">
        <NavBar />
        <AppHeader />
        <div className={style.section_container} style={{ minHeight: height }}>
          {children}
          <div className={style.footer_mobile}>
            <Footer />
          </div>
        </div>
        <div className={style.footer_desktop}>
          <Footer />
        </div>

        {/* ✅ El modal vive ahora solo en el layout privado */}
        <TokenRefreshModal
          isOpen={refreshModal.isOpen}
          onClose={refreshModal.close}
          onRefresh={refreshModal.refresh}
          isLoading={refreshModal.isLoading}
        />
      </section>
    </div>
  );
};

export default PrivateLayout;
